import { DATE_TIME_FORMAT, FormatDate} from "../../../../constants";


interface PaymentRejectedFormProps {
    amount: number;
    reason: string;
    applicantRespondedAt: Date;
}

export const PaymentRejectedForm: React.FC<PaymentRejectedFormProps> = (props) => {
    return (
        <div
        style={{
          backgroundColor: "white",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px",
          paddingRight: "20px",
          margin: 10,
          textAlign: "left",
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
        }}
      >
        <div>
            The request of US${props.amount} for {props.reason} was rejected by the applicant.
            <div
            className="shadow-sm"
            style={{
                margin: "10px 5px",
                padding: "10px",
                color: "black",
                borderRadius: "8px",
                background: "#FFF3CD",
                overflow: "auto",
                textAlign: "center",
            }}
            >
                <strong>US${props.amount} Payment Request Rejected</strong>
                <br/>
                {FormatDate(props.applicantRespondedAt, DATE_TIME_FORMAT).toString()}
            </div>
        </div> 
    </div>
    )
}
